import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";

/**
 * API handler to fetch recent orders
 *
 * @returns {Promise<Object>} - Response with recent orders
 * @throws Will throw an error if the request fails
 *
 * Mishra
 */
const getRecentOrders = async () => {
  return await apiCall(`${AUTH_ROUTES.ORDER_API_ENDPOINT}`, {
    method: "GET",
  });
};

export default getRecentOrders;
